import initialState from './CategoriesInitialState';
import reducers from './CategoriesReducer';

export default {
  initialState,
  reducers,
};
